import cx from 'classnames';
import { useContext, useEffect, useRef } from 'react';
import SuggestedFilterChips from '@/common/SuggestedFilterChips';
import SuggestedFiltersContext from '~/context/srp/SuggestedFiltersContext';
import useSuggestedFilterChipItems from '~/hooks/srp/useSuggestedFilterChipItems';
import useTrackSuggestedFilterPositions from '~/hooks/srp/useTrackSuggestedFilterPositions';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  containerNegativeMargin,
  containerPadding
} from '../MainLayout.styles';

type OwnProps = {
  className?: string;
};

function QuickFilters({ className }: OwnProps) {
  const { suggestedFilters } = useContext(SuggestedFiltersContext);
  const {
    isLoading,
    items,
    show2RowSuggestedFilters,
    showCounts,
    showSuggestedFilters
  } = useSuggestedFilterChipItems();
  const scrollRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useTrackSuggestedFilterPositions(scrollRef, items.length);

  useEffect(() => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollLeft = 0;
  }, [scrollRef, suggestedFilters.isLoading]);

  if (!showSuggestedFilters) return null;

  return (
    <div
      className={cx(
        className,
        containerNegativeMargin,
        'relative mt-xl flex min-h-24 items-center overflow-hidden sm:mt-xl',
        { hidden: !isLoading && items.length === 0 }
      )}
      data-testid="srp-quick-filters"
      ref={containerRef}
    >
      <div
        className={cx(containerPadding, 'no-scrollbar flex overflow-x-auto')}
        ref={scrollRef}
      >
        {show2RowSuggestedFilters ? (
          <SuggestedFilterChips
            isLoading={isLoading}
            items={items}
            layout="twoRow"
            showCounts={showCounts}
          />
        ) : (
          <div className="flex items-center gap-md sm:flex-wrap ">
            <SuggestedFilterChips
              isLoading={isLoading}
              items={items}
              showCounts={showCounts}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default withErrorBoundary(QuickFilters, {
  section: 'SRP QuickFilters'
});
